import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";
import { Composition, DesignParameter, LightAndShadow, LoraModel, Material, Model, RefStructure, RefStyle } from "@/types/design";

type ModeState = {
  design: DesignParameter;
  amount: number;
  currentGen: string;
  files: string[]
};

const initialState: ModeState = {
  design: {
    mode: "新手模式",
    basesetting: "最优",
    generatetype: "",
    smallmodel: [] as LoraModel[],
    bigmodel: {} as Model,
    vae: "",
    refstructure: [] as RefStructure[],
    refstyle: [] as RefStyle[],
    n_iter: 1,
    ratio: "1:1",
    width: 512,
    height: 512,
    seed: -1,
    steps: 30,
    cfgscale: 7,
    picturedetail: 10,
    lightshadow: [] as LightAndShadow[],
    composition: {} as Composition,
    material: {} as Material,
  } as DesignParameter,
  amount: 1,
  currentGen: "TXT2IMG",
  files: []
};

export const modeSlice = createSlice({
  name: "mode",
  initialState,
  reducers: {
    updateDesign: (state, action: PayloadAction<DesignParameter>) => {
      state.design = action.payload;
    },
    resetDesign: (state) =>{
      const mode = state.design.mode;
      const newState ={design: {...initialState.design, mode:mode },amount: 1,currentGen: "TXT2IMG",files: []}
      return newState
    },
    setCurrentGen: (state, action: PayloadAction<string>) => {
      state.currentGen = action.payload;
    },
    setGenCoin: (state, action: PayloadAction<number>) => {
      state.amount = action.payload;
    },
    updateRefStructure: (state, action: PayloadAction<RefStructure[]>) => {
      state.design.refstructure = action.payload;
    },
    updateRefStyle:(state, action: PayloadAction<RefStyle[]>) => {
      state.design.refstyle = action.payload;
    },
    updateWithandHeight:(state, action: PayloadAction<{width: number,height: number}>) => {
      state.design.width = action.payload.width;
      state.design.height = action.payload.height;
    },
    updateFiles:(state,action:PayloadAction<string[]>)=>{
      state.files = action.payload
    }
  },
});

export const selectMode = (state: RootState) => state.mode;
export const { updateDesign, resetDesign, setCurrentGen, setGenCoin, updateRefStructure, updateRefStyle, updateWithandHeight, updateFiles } = modeSlice.actions;
export default modeSlice.reducer;
